import { render, staticRenderFns } from "./PersonalCenter.vue?vue&type=template&id=5228e951&scoped=true&"
import script from "./personalcenter.js?vue&type=script&lang=js&"
export * from "./personalcenter.js?vue&type=script&lang=js&"
import style0 from "./PersonalCenter.vue?vue&type=style&index=0&id=5228e951&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5228e951",
  null
  
)

export default component.exports